export const DAILY = ["Daily","%D %b %Y"]
export const WEEKLY = ["Weekly","Week %u %x"]
export const MONTHLY =["Monthly","%m %Y"]
export const YEARLY = ["Yearly","Year %Y"]

export const TimeSpans = [DAILY,WEEKLY,MONTHLY,YEARLY];
